import { writable } from 'svelte/store'
import { persisted } from 'svelte-persisted-store'

export const servers = writable({})

// ######## READER ########
export const lastScrollDirection = writable('UP')
/** `true` = show app header chrome; reader updates from scroll; app reads on reader routes only. */
export const readerHeaderVisibleStore = writable(true)
export const showReaderOptions = writable(false)
export const readerKind = writable("")
export const readerOpts = persisted('readerOpts', {
  fontSize: '20',
  justify: true,
  bodyFont: 'fira-code',
  /** Horizontal inset per side as % of reader width (0–50). */
  margin: {
    novel: 5,
    comics: 0,
  },
  verticalSpacing: '20',
  brightness: 100,
  contrast: 100,
  comicsTranslate: false,
  novelTranslate: false,
  comicsEnhance: true,
})

import { readable } from 'svelte/store';

function createPathStore() {
  return readable(window.location.pathname, (set) => {
    const update = () => set(window.location.pathname);

    // Listen to back/forward
    window.addEventListener('popstate', update);

    // Patch pushState & replaceState once
    const { pushState, replaceState } = history;

    history.pushState = function (...args) {
      pushState.apply(this, args);
      update();
    };

    history.replaceState = function (...args) {
      replaceState.apply(this, args);
      update();
    };

    return () => {
      window.removeEventListener('popstate', update);
      history.pushState = pushState;
      history.replaceState = replaceState;
    };
  });
}

export const currentPath = createPathStore();
